import { Component, ElementRef, HostListener, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export const PALETTE_COLORS = [
  '#000000', '#424242', '#757575', '#bdbdbd', '#ffffff',
  '#f44336', '#ff9800', '#ffeb3b', '#4caf50', '#00bcd4',
  '#2196f3', '#3f51b5', '#9c27b0', '#e91e63', '#795548',
];

@Component({
  selector: 'mce-color-palette',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './color-palette.component.html',
  styleUrl: './color-palette.component.scss',
})
export class ColorPaletteComponent {

  readonly label = input.required<string>();
  readonly currentColor = input<string | null>(null);
  readonly removeLabel = input('Remove colour');

  readonly colorSelected = output<string | null>();

  readonly colors = PALETTE_COLORS;

  open = false;

  constructor(private readonly elRef: ElementRef) {}

  toggle() {
    this.open = !this.open;
  }

  select(color: string | null) {
    this.colorSelected.emit(color);
    this.open = false;
  }

  openPicker(input: HTMLInputElement) {
    input.click();
  }

  pickerChanged(input: HTMLInputElement) {
    this.select(input.value);
  }

  @HostListener('document:mousedown', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.open = false;
    }
  }
}
